module.exports = "/1st/2026/packs/i_narrow_down_active02-ccbac042f1c05b163b104be70ea05432.svg";